// NPM Imports
import React from "react";

// Component Imports
import DocumentRow from "./DocumentRow";

// Internal Imports
import { DOCUMENTS } from "../../../constants";

import { emptyContainer } from "../../../utils/documentUtils";

// Destructuring
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class DocumentBlocks extends React.Component {
  /**
   * Get the Document Items View based on some conditions -
   * Show the Empty Document Placeholder Image if -
   * 1. there is no drag &
   * 2. there is only empty section placeholder in section list
   * Else - show the Document Component View
   */
  render() {
    const { layout } = this.props;
    let decideComponents = this.props.components;
    let decideLayout = this.props.layout;
    let { emptyBlockConfig } = this.props;
    // To check whether Body view is empty or not
    if (this.props.blockType === "BODY") {
      // Check the body view component list
      const checkBodyViewRowList = Object.keys(this.props.components).filter(
        componentId =>
          this.props.components[componentId] &&
          this.props.components[componentId].content &&
          !(
            this.props.components[componentId].content.type ===
              DOCUMENT_COMPONENT_TYPES.COVERPAGE ||
            this.props.components[componentId].content.type ===
              DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER
          ),
      );
      // Check for the emptyContainer
      const hasEmptyContainer = Object.keys(this.props.components).filter(
        componentId =>
          this.props.components[componentId] &&
          this.props.components[componentId].content &&
          this.props.components[componentId].content.type ===
            DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER,
      );

      // If there is no components in bodyView & no emptyContainer then, add the "emptyContainer"
      if (
        checkBodyViewRowList &&
        checkBodyViewRowList.length === 0 &&
        hasEmptyContainer &&
        hasEmptyContainer.length === 0
      ) {
        const emptyComponent = emptyContainer();
        emptyBlockConfig = { flag: true, type: "BODY" };
        decideComponents = {
          [emptyComponent.id]: {
            row: undefined,
            col: undefined,
            dbRowIndex: 0,
            dbColIndex: 0,
            content: emptyComponent,
          },
          ...this.props.components,
        };
        decideLayout = [[emptyComponent.id], ...layout];
      }
    }
    if (Array.isArray(decideLayout) && decideComponents) {
      return decideLayout.map((sectionRowList, rowIndex) =>
        Array.isArray(sectionRowList) && sectionRowList.length > 0 ? (
          <DocumentRow
            rowIndex={rowIndex}
            rowList={sectionRowList}
            itemType={this.props.itemType}
            mode={this.props.mode}
            blockType={this.props.blockType}
            isLocked={this.props.isLocked}
            components={decideComponents}
            componentMeta={this.props.componentMeta}
            addComponent={this.props.addComponent}
            updateComponent={this.props.updateComponent}
            deleteComponent={this.props.deleteComponent}
            cloneSection={this.props.cloneSection}
            emptyBlockConfig={emptyBlockConfig}
            isActiveHeaderFooter={this.props.isActiveHeaderFooter}
            docComponentSectionList={this.props.docComponentSectionList}
            removeHighlightSelection={this.props.removeHighlightSelection}
            updateHoveredSectionId={this.props.updateHoveredSectionId}
            removeActiveComponents={this.props.removeActiveComponents}
            showDocumentDiffView={this.props.showDocumentDiffView}
            deleteSection={this.props.deleteSection}
            isSharedDocument={this.props.isSharedDocument}
            isDocumentLocked={this.props.isDocumentLocked}
            toggleSectionLockUnlock={this.props.handleSectionLockUnlock}
            hoveredActiveComponentId={this.props.hoveredActiveComponentId}
            // Ref related props
            customToolbarRef={this.props.customToolbarRef}
            signatureWrapperRef={this.props.signatureWrapperRef}
            setRefsByType={this.props.setRefsByType}
            // Drag/Drop related props
            draggedSection={this.props.draggedSection}
            draggedPosition={this.props.draggedPosition}
            dragggedOverData={this.props.dragggedOverData}
            onPlaceholderDragOver={this.props.onPlaceholderDragOver}
            onPlaceholderDragEnter={this.props.onPlaceholderDragEnter}
            onPlaceholderDragLeave={this.props.onPlaceholderDragLeave}
            onPlaceholderDrop={this.props.onPlaceholderDrop}
            // Template related props
            handleComponentLockUnlock={this.props.handleComponentLockUnlock}
            tableColorpickerDropdownRef={this.props.tableColorpickerDropdownRef}
            match={this.props.match}
          />
        ) : null,
      );
    }
    return null;
  }
}

export default DocumentBlocks;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DocumentBlocks/DocumentBlocks.js